import { render, staticRenderFns } from "./bankcard.vue?vue&type=template&id=72ed5ef3&"
import script from "./bankcard.vue?vue&type=script&lang=js&"
export * from "./bankcard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports